import { parseISO } from "date-fns";
import { Utils } from "../../common/Utils";
import { Gap_Attribute } from "../../constants";
import { IChecklists } from "../../interfaces/CheckLists";
import { AbstractAttributeBase } from "./AbstractAttributeBase";
import { AttributeRequestActivity } from "./AttributeRequestActivity";

// export class GapAttribute extends AbstractAttribute {
export class GapAttribute extends AbstractAttributeBase {
  static reason = Gap_Attribute.reason;

  category: any;
  currentProficiency: any;
  requiredProficiency: any;
  validationRequestId!: any;
  requestedProficiency!: any;
  reasonLabel: any;
  checklists: IChecklists[];

  constructor(index: any, data: any) {
    super(index, data);

    this.employeeAttributeId = data.employeeAttributeId;
    this.attributeName = data.attributeDefinitionName;
    this.category = data.attributeDefinitionCategory;
    this.required = data.jobAttributeRequirementType === 1;
    this.mandatory = data.jobAttributeRequirementType === 2;
    this.currentProficiency = data.employeeAttributeProficiencyValue;
    this.requiredProficiency = data.jobAttributeProficiencyMinimum;
    if (data.employeeAttributeValidationRequestState != null) {
      this.validationRequestId = data.employeeAttributeValidationRequestId;
      this.validationRequestState = Object.values(AbstractAttributeBase.status)[
        data.employeeAttributeValidationRequestState
      ];
      this.requestedProficiency = data.employeeAttributeValidationRequestProficiencyValue;
      this.requestedExpiryDate = data.employeeAttributeValidationRequestExpiryDate
        ? new Date(parseISO(data.employeeAttributeValidationRequestExpiryDate))
        : null;
    }
    this.reason = Object.values(GapAttribute.reason)[data.gapReason];
    this.reasonLabel = this.reason.label;

    this.pendingExpiryDate = data.pendingExpiryDate
      ? data.pendingExpiryDate
      : this.requestedExpiryDate || this.currentExpiryDate;

    this.checklists = data.checklists
      ? data.checklists.map((c: IChecklists) => ({
          ...c,
          answers: Utils.getAnswersFromChecklist(c)
        }))
      : [];

    if (data.validationRequest) {
      this.requestedProficiency = data.validationRequest.proficiencyValue;
    }

    if (this.mandatory) this.type = AbstractAttributeBase.type.mandatory.translationKey;
    else if (this.required) this.type = AbstractAttributeBase.type.required.translationKey;
    else this.type = AbstractAttributeBase.type.desirable.translationKey;
  }

  hasValidationRequest() {
    return this.validationRequestState;
  }

  isNeedsFeedback() {
    return (
      this.validationRequestState &&
      this.validationRequestState === AbstractAttributeBase.status.feedback
    );
  }

  isLowProficiency() {
    return this.reason === GapAttribute.reason.lowProficiency;
  }

  isMissing() {
    return this.reason === GapAttribute.reason.missing;
  }

  isGap() {
    return true;
  }

  loadRequestActivity(context: any, updateCache: any) {
    return new Promise((resolve, reject) => {
      if (!this.requestActivity || updateCache === true) {
        this.requestActivity = new AttributeRequestActivity({
          attributeId: this.employeeAttributeId,
          resolve: (requestActivity: any) => {
            resolve(requestActivity);
          },
          reject,
          context
        });
      } else resolve(this.requestActivity);
    });
  }

  deleteChecklistAssignment(checklistAssignmentId: string) {
    this.checklists = this.checklists.filter((c: any) => c.assignmentId !== checklistAssignmentId);
  }
}
